__turbopack_context__.v({
  "hovered": "QuickLinkBox-module-scss-module__8DoN2W__hovered",
  "showAnker": "QuickLinkBox-module-scss-module__8DoN2W__showAnker",
  "slideUp": "QuickLinkBox-module-scss-module__8DoN2W__slideUp",
  "specialButtons": "QuickLinkBox-module-scss-module__8DoN2W__specialButtons",
  "theGoTopIcon": "QuickLinkBox-module-scss-module__8DoN2W__theGoTopIcon",
  "theIconItself": "QuickLinkBox-module-scss-module__8DoN2W__theIconItself",
});
